/**
 * The reference checkout's numbered section card (grep `===== CHECKOUT` in
 * `Dens N Dente Tailwind.dc.html`): a `bg-card` xl card whose header is a 28px
 * numbered circle beside a bold title. `n` is optional — the review step reuses
 * the same chrome without numbers (a recap isn't a progression).
 *
 * `tone="warning"` turns the circle amber — the reference's `shipBadgeCls` /
 * `payBadgeCls` treatment for a section that still needs attention (missing
 * address, failed validation). The background transition is what makes the flip
 * read as state, not a repaint.
 *
 * Extra props (`...rest`) land on the root div so callers can plant the
 * reference's scroll anchors (`data-co-ship` / `data-co-pay`) for
 * scroll-to-error.
 */
export default function CheckoutSectionCard({
  n,
  title,
  tone,
  children,
  className = "",
  ...rest
}) {
  return (
    <div
      className={`rounded-xl border border-line-subtle bg-card px-[var(--space-6)] py-[var(--space-6)] shadow-sm ${className}`.trim()}
      {...rest}
    >
      <div className="mb-[var(--space-4)] flex items-center gap-[10px]">
        {n !== undefined && (
          <span
            className={`inline-flex h-[28px] w-[28px] shrink-0 items-center justify-center rounded-full text-sm font-bold text-white [transition:background_var(--duration-fast)] ${
              tone === "warning" ? "bg-[var(--warning-500)]" : "bg-blue-900"
            }`}
          >
            {n}
          </span>
        )}
        <h3 className="text-md font-bold">{title}</h3>
      </div>
      {children}
    </div>
  );
}
